import { Select } from '@chakra-ui/react';
import { useState, useImperativeHandle, forwardRef } from 'react';

const DataGridSelect = forwardRef(({ options, data, required, node, column }, ref) => {
    const [selected, setSelected] = useState(data[column.getColDef().field] ?? '-1');

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                const parsed = parseInt(selected);

                return selected === '-1' ? '' : options.find(({ id }) => id === parsed)?.id;
            },
        };
    });

    return (
        <Select value={selected} onChange={(event) => setSelected(event.target.value)} bg="unset">
            {!required && <option value="-1">-</option>}

            {options.map((type) => (
                <option key={type.id} value={type.id}>
                    {type.description}
                </option>
            ))}
        </Select>
    );
});

export default DataGridSelect;
